import { render, staticRenderFns } from "./DispatcherReport.vue?vue&type=template&id=4c1abed5"
import script from "./DispatcherReport.vue?vue&type=script&lang=js"
export * from "./DispatcherReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports